type ErrorMetadata = Record<string, unknown>;

export type AppErrorContext = {
  source: "apiClient" | "ErrorBoundary" | "ui" | string;
  action?: string;
  endpoint?: string;
  statusCode?: number;
  errorId?: string;
  requestId?: string;
  errorType?: string;
  timestamp?: string;
  metadata?: ErrorMetadata;
};

const errorCounter = new Map<string, number>();

function fingerprintError(message: string, context: AppErrorContext): string {
  return [
    context.source,
    context.action || "",
    context.endpoint || "",
    context.statusCode || "",
    context.errorType || "",
    message,
  ].join("|");
}

export function getErrorMessage(error: unknown): string {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "An unexpected error occurred";
}

export function logAppError(error: unknown, context: AppErrorContext): void {
  const message = getErrorMessage(error);
  const fingerprint = fingerprintError(message, context);
  errorCounter.set(fingerprint, (errorCounter.get(fingerprint) || 0) + 1);

  console.error("[AppError]", {
    message,
    count: errorCounter.get(fingerprint),
    ...context,
    rawError: error,
  });
}

export function getErrorCount(error: unknown, context: AppErrorContext): number {
  const message = getErrorMessage(error);
  const fingerprint = fingerprintError(message, context);
  return errorCounter.get(fingerprint) || 0;
}
